export enum Action {
  View = 'view',
  Edit = 'edit',
  Create = 'create',
  Delete = 'delete',
  Generate = 'generate',
  All = 'ALL',
}

export enum Subject {
  All = 'ALL',
  Patient = 'Patient',
  Order = 'Order',
  TestRecord = 'TestRecord',
  Algo = 'Algo',
  Device = 'Device',
  TestRoom = 'TestRoom',
  DeviceStatus = 'DeviceStatus',
  // Device shipping legs (carrier / tracking / est. delivery / direction) and
  // their history. Split from `Device` because shipping is editable by the
  // clinical roles that handle devices day to day, while editing a device
  // itself is not — mirrors the /devices/:id/shipments allowlist on the API.
  // Covers viewing, not just changing.
  DeviceShipment = 'DeviceShipment',
  // Taking a device out of the lab's active inventory and putting it back.
  // Split from `Device` because it is an inventory decision rather than an edit
  // of the device itself: lab managers and admins make it without being able to
  // change the device's own fields — mirrors the /devices/:id/deactivate
  // allowlist on the API.
  DeviceActivation = 'DeviceActivation',
  // The inventory fields of a device — the label a lab gives it and the
  // department it belongs to. Split from `Device` because the people who run
  // the floor keep those up to date, while everything describing the hardware
  // stays with the roles that provision it — mirrors the PATCH /devices/:id
  // allowlist on the API.
  DeviceInventory = 'DeviceInventory',
  Department = 'Department',
  Annotation = 'Annotation',
  Analysis = 'Analysis',
  // Exporting a test's signals as EDF (generate + download). Split from `Algo`
  // so a role can run auto-scoring and filters without being able to take data
  // out of the system — mirrors the /tests/:id/export-edf allowlist on the API.
  EdfExport = 'EdfExport',
  // Forwarding a mobile S3 backup over a test's signals ("Upload Backup File",
  // DWA-1484). Internal debug tooling, deliberately narrower than TestRecord
  // edit — mirrors the /test-files allowlist on the API.
  TestBackupFile = 'TestBackupFile',
  // The technician's free-text note on a study. Everyone who can open a study
  // reads it; writing it mirrors the PUT /tests/:id/notes/tech allowlist on
  // the API.
  TechNote = 'TechNote',
  // The scorer's free-text note on a study, read like the technician's. Written
  // by the roles that score, mirroring PUT /tests/:id/notes/scorer.
  ScorerNote = 'ScorerNote',
  ReferringDoctors = 'ReferringDoctors',
  Report = 'Report',
  // Approving and signing a report (the report lock). Split from `Report` so a
  // role can save/submit a report without being allowed to sign it.
  SignedReport = 'SignedReport',
  // Reusable report texts saved from the reports screen ("Save as Custom").
  // Split from `Report` so a role can edit report texts without being allowed
  // to persist them as account-wide custom options.
  CustomText = 'CustomText',
  User = 'User',

  // UI elements
  DashboardPage = 'DashboardPage',
  PatientsPage = 'PatientsPage',
  TestsPage = 'TestsPage',

  TestsLogs = 'TestsLogs',
  TestsReport = 'TestsReport',
  LiveTestsPage = 'LiveTestsPage',

  DevicesPage = 'DevicesPage',
  SettingsPage = 'SettingsPage',
  TestRoomPage = 'TestRoomPage',
  ReportsPage = 'ReportsPage',
  WorkingAreaPage = 'WorkingAreaPage',
  SystemLogsPage = 'SystemLogsPage',
  PSGHSTestsPage = 'PSGHSTestsPage',
  RAWTestsPage = 'RAWTestsPage',
  PhysicianDashboardPage = 'PhysicianDashboardPage',
}



export type AbilityTuple = [action: Action, subject: Subject];
